import { render, staticRenderFns } from "./BusinessProcessList.vue?vue&type=template&id=1f4cc1c2&scoped=true&"
import script from "./BusinessProcessList.vue?vue&type=script&lang=js&"
export * from "./BusinessProcessList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProcessList.vue?vue&type=style&index=0&id=1f4cc1c2&lang=scss&scoped=true&"
import style1 from "./BusinessProcessList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4cc1c2",
  null
  
)

export default component.exports